import React, { useEffect, useMemo, useState } from 'react';
import { Column } from 'react-table';
import { useTranslation } from 'react-i18next';
import DefaultTable from 'components/tables/DefaultTable/DefaultTable';
import './EditClientOrderDetails.scss';
import CURRENCY from 'utils/constants/currency';
import QuantityInput from 'components/inputs/QuantityInput/QuantityInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClose, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import PriceInput from 'components/PriceInput/PriceInput';
import { IParts } from 'interfaces/price';
import useHttp from 'utils/hooks/useHttp';
import { useSearchParams } from 'react-router-dom';
import { CodeSupplier, IOrderItemTableEdit } from 'models/order';
import { notify } from 'utils/marketplace';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import ExpandButton from 'components/tables/TableMoreInformation/ExpandButton/ExpandButton';
import i18n from 'i18n';
import Select from 'react-select';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import Modal from 'components/modal/Modal';
import OrderDiscountModal from './OrderDiscountModal/OrderDiscountModal';
import TextInput from 'components/inputs/TextInput/TextInput';
import TextareaInput from 'components/inputs/TextareaInput/TextareaInput';

type FilterType = 'equal' | 'different' | 'all';

type Props = {
  data
  setNewRefData: (data: IParts | undefined) => void;
  newRefData,
  setIsModified: (isModified: boolean) => void;
  updateOrder: boolean;
  setUpdateOrder: (updateOrder: boolean) => void;
  setLoading: (loading: boolean) => void;
  setOpenModal: (openModal: boolean) => void;
  setEditOrderItems: (editOrderItems: boolean) => void;
  setRequestGetOrderList: (requestGetOrderList: boolean) => void;
  orderSymmary
  hasSpecialPrice: boolean
  valueDiscount: CodeSupplier[]
  comment: string

};

const EditClientOrderDetails: React.FC<Props> = (props) => {
  const user = JSON.parse(localStorage.getItem('userData')!);
  const { t } = useTranslation();
  const [dataTable, setDataTable] = useState<IOrderItemTableEdit[]>(props.data);
  const [dataTableFiltred, setDataTableFiltred] = useState<IOrderItemTableEdit[]>(props.data);
  const [filterSelected, setFilterSelected] = useState<FilterType>('all');
  const http = useHttp();
  const [searchParams] = useSearchParams();
  const { isMobile } = useDeviceDetect();
  const [coefficient, setCoefficient] = useState('-');
  const [specialPrice, setSpecialPrice] = useState(false);
  const [openModalDiscount, setOpenModalDiscount] = useState(false);
  const [allDiscount, setAllDiscount] = useState<number | String>(props.valueDiscount.find(item => item.codfou === 'global')?.discount || 0);
  const [message, setMessage] = useState<string>(props.comment || '');

  const Status_Filter: { value: FilterType; label: string }[] = [
    { value: 'all', label: t('_all') },
    { value: 'equal', label: t('_sort_equal_price') },
    { value: 'different', label: t('_sort_different_price') },
  ];

  const [listCodesAndSuppliers, setListCodesAndSuppliers] = useState<CodeSupplier[]>([]);

  useEffect(() => {

    if (props.data.length > 0) {
      const unique = Array.from(
        new Map(
          props.data.map(item => [
            item.codfou,
            { codfou: item.codfou, supplier: item.supplier, discount: props.valueDiscount.find(discount => discount.codfou === item.codfou)?.discount || 0 },
          ])
        ).values()
      ) as CodeSupplier[];

      setListCodesAndSuppliers(unique);
    }
  }, [props.data, props.valueDiscount]);


  useEffect(() => {
    if (dataTable.length > 0) {

      setListCodesAndSuppliers((prevList) => {
        // păstrăm doar codfou care încă există în dataTable
        const validCodfou = dataTable.map((item) => item.codfou);
        const filtered = prevList.filter((d) => validCodfou.includes(d.codfou));

        // adăugăm codfou noi din dataTable care nu sunt încă în listă
        const toAdd = dataTable
          .filter((item) => !filtered.some((d) => d.codfou === item.codfou))
          .map((item) => ({
            codfou: item.codfou,
            supplier: item.supplier,
            discount: 0,
          }));

        return [...filtered, ...toAdd];
      });
    } else {

      setListCodesAndSuppliers([]);
    }
  }, [dataTable, props.valueDiscount]);

  useEffect(() => {
    const sortById = (arr: IOrderItemTableEdit[]) => [...arr].sort((a, b) => a.id - b.id);

    const isEqual = (a: IOrderItemTableEdit[], b: IOrderItemTableEdit[]) => {
      if (a.length !== b.length) { return false; }

      return a.every((itemA, index) => {
        const itemB = b[index];

        return (
          itemA.id == itemB.id &&
          itemA.reference == itemB.reference &&
          Number(itemA.quantity) == Number(itemB.quantity) &&
          Number(itemA.price) == Number(itemB.price) &&
          itemA.total == itemB.total &&
          itemA.supplier == itemB.supplier &&
          itemA.status == itemB.status &&
          itemA.codfou == itemB.codfou &&
          Number(itemA.buy_price) == Number(itemB.buy_price) &&
          Number(itemA.taux) == Number(itemB.taux)
        );
      });
    };

    const hasChanged = !isEqual(sortById(dataTable), sortById(props.data));

    props.setIsModified(hasChanged && dataTable.length !== 0);
  }, [dataTable, props.data]);

  const show = (id: string, type, event?: React.MouseEvent) => {
    event?.stopPropagation();
    document.getElementById(String(id))!.style.display = type;
  };

  const setValueItems = (value: { id: number; index: number; quantity: number }) => {
    setDataTable((prevData) =>
      prevData.map((item) =>
        item.id === value.id ? { ...item, quantity: value.quantity, total: item.price * value.quantity } : item
      )
    );

  };


  const handleInputChangePrice = (price, id, reference, buy_price: number) => {
    let calculatedTaux = 1;

    if (buy_price !== 0) {
      calculatedTaux = +(price / buy_price).toFixed(2);
    }

    setDataTable((prevData) => {
      const newData = prevData.map((item) =>
        item.id === id && item.reference === reference ? { ...item, price: price, total: price * item.quantity, taux: calculatedTaux } : item
      );

      // Calcul coeficient pe baza noilor date
      const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
      const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '-';

      setCoefficient(averageTauxFinal);

      return newData;
    });
  };

  const handleInputChangeTaux = (taux, id, reference, buy_price) => {
    if (buy_price !== 0) {
      const calculatedPrice = +(taux * buy_price).toFixed(2);

      // actualizăm tabelul și calculăm coeficientul pe baza datelor noi
      setDataTable((prevData) => {
        const newData = prevData.map((item) =>
          item.id === id && item.reference === reference
            ? {
              ...item,
              taux: taux,
              price: calculatedPrice,
              total: +(calculatedPrice * item.quantity).toFixed(2),
            }
            : item
        );

        // calculăm coeficientul pe baza noilor valori
        const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
        const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '-';

        setCoefficient(averageTauxFinal);

        return newData;
      });
    }
  };

  const handleInputChangeBuyPrice = (buy_price, id, reference, price) => {

    if (buy_price !== 0) {
      const calculatedTaux = +(price / buy_price).toFixed(2);

      // actualizăm tabelul și calculăm coeficientul pe baza datelor noi
      setDataTable((prevData) => {
        const newData = prevData.map((item) =>
          item.id === id && item.reference === reference
            ? {
              ...item,
              taux: calculatedTaux,
              buy_price: buy_price,
            }
            : item
        );

        // calculăm coeficientul pe baza noilor valori
        const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
        const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '-';

        setCoefficient(averageTauxFinal);

        return newData;
      });
    }
  };


  const removeRow = (reference, id, codfou) => {
    const tooltipId = 'delete' + id + reference;
    const tooltip = document.getElementById(tooltipId);

    if (tooltip) { tooltip.style.display = 'none'; }

    setDataTable((prevData) => {
      const newData = prevData.filter(
        (item) => !(item.reference.includes(reference) && item.id === id && item.codfou === codfou)
      );

      // recalculăm coeficientul
      const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
      const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '-';

      setCoefficient(averageTauxFinal);

      return newData;
    });
  };

  useEffect(() => {

    if (props.newRefData) {

      const ifexists = dataTable.some((item) => item.reference === props.newRefData.reference);

      if (ifexists) {
        notify(t('_item_already_exists'), 'error');
      }

      const maxId = dataTable.reduce((max, item) => {
        return item.id > max ? item.id : max;
      }, 0);

      const newItem = {
        id: maxId + 1,
        reference: props.newRefData.reference,
        quantity: props.newRefData.quantity,
        price: props.newRefData.price || 0,
        supplier: props.newRefData.name,
        status: '',
        country_restriction: props.newRefData.country_restriction,
        description: props.newRefData.description,
        supplier_id: props.newRefData.supplier_id,
        catalogId: 'AUT',
        is_manufacturer: true,
        codfou: props.newRefData.codfou,
        total: props.newRefData.price * props.newRefData.quantity,
        taux: props.newRefData.taux || 1,
        buy_price: props.newRefData.buy_price || 0,
        current_aol_price: props.newRefData.price || 0,
        client_reference: props.newRefData?.reference || '',
        buy_current_aol_price: props.newRefData.buy_price || 0,
        old_reference: '',
      };

      const newData = [newItem, ...dataTable]; // adaugă noul item

      setDataTable(newData);
      props.setNewRefData(undefined); // resetează newRefData
    }


  }, [props.newRefData]);


  useEffect(() => {

    if (props.updateOrder) {

      let discountList: CodeSupplier[] = [];

      if (specialPrice) {
        discountList = [
          {
            codfou: 'global',
            supplier: 'global',
            discount: +allDiscount,
          },
          ...listCodesAndSuppliers,
        ];
      } else {
        setAllDiscount(0);
        setListCodesAndSuppliers((prevList) =>
          prevList.map((item) => ({ ...item, discount: 0 }))
        );
      }

      const datasend = {
        items_order: dataTable,
        is_special_price: specialPrice,
        discount: discountList,
        comment: message
      };

      http.order.updateOrderItems(String(searchParams.get('id')), datasend)
        .then(() => {
          props.setLoading(false);
          notify(t('_success'), 'success');
        })
        .catch(() => notify(t('_error')))
        .finally(() => {
          props.setLoading(false);
          props.setIsModified(false);
          props.setOpenModal(false);
          props.setEditOrderItems(false);
          props.setUpdateOrder(false);
          props.setRequestGetOrderList(true);
        });
    }

  }, [props.updateOrder]);

  const columnsOrderItems = useMemo(
    (): Column<IOrderItemTableEdit>[] => [
      {
        id: 'expander',
        Header: '',
        width: 15,
        Cell: (row) => {
          return <ExpandButton row={row.row} />;
        },
      },
      {
        Header: `${t('_reference_submited')}`,
        accessor: 'reference',
      },
      {
        Header: `${t('_mark')}`,
        accessor: 'supplier',
      },
      {
        Header: `${t('_buy_price')}`,
        accessor: 'buy_price',
        Cell: (row) => {
          if (specialPrice) {
            return <div className="price-input" >
              <div >
                {CURRENCY[user!.currency]}
              </div>
              <PriceInput key={row.row.original.id} value={Number(row.row.original.buy_price)} handleInputChangePrice={handleInputChangeBuyPrice} id={row.row.original.id} reference={row.row.original.reference} buy_price={row.row.original.price} />
            </div>;
          }

          return <span>{row.value ? CURRENCY[user!.currency] + ' ' + row.value : '-'}</span>;
        }
      },
      {
        Header: `${t('_coefficient')}`,
        accessor: 'taux',
        Cell: (props) =>
          <div className="price-input">

            <PriceInput disabled={props.row.original.buy_price == null || props.row.original.buy_price == 0} value={Number(props.row.original.taux)} handleInputChangePrice={handleInputChangeTaux} id={props.row.original.id} reference={props.row.original.reference} key={props.row.original.id} buy_price={Number(props.row.original.buy_price)} />
          </div>

      },
      {
        Header: `${t('_sell_price')}`,
        accessor: 'price',
        Cell: (props) => <div className="price-input" >
          <div >
            {CURRENCY[user!.currency]}
          </div>

          <PriceInput key={props.row.original.id} className={props.row.original.price == props.row.original.current_aol_price ? 'green' : 'red'} value={Number(props.row.original.price)} handleInputChangePrice={handleInputChangePrice} id={props.row.original.id} reference={props.row.original.reference} buy_price={Number(props.row.original.buy_price)} />
        </div>

      },
      {
        Header: `${t('_qte')}`,
        accessor: 'quantity',
        Cell: (props) => {
          return <QuantityInput value={props.row.original.quantity} index={props.row.original.id} setValueItems={setValueItems} id={props.row.original.id} key={props.row.original.id} />;

        }

      },
      {
        Header: `${t('_status')}`,
        accessor: 'status',

      },
      {
        Header: 'Total H.T',
        accessor: 'total',
        Cell: (row) => {
          return <div className="total">{CURRENCY[user!.currency]}{row.value.toFixed(2)} </div>;
        }
      },
      {
        Header: `${t('_actions')}`,
        Cell: (props) => {

          return <div className="actions">

            <div className="remove" onClick={(event) => show('delete' + props.row.original.id + props.row.original.reference, 'block', event)} >
              <FontAwesomeIcon icon={faTrashCan} />
              <div className="tooltip-order"
                id={String('delete' + props.row.original.id + props.row.original.reference)}
                onMouseLeave={(event) =>
                  setTimeout(() => {
                    show(String('delete' + props.row.original.id + props.row.original.reference), 'none', event);
                  }, 100)
                }
              >
                <div className="tooltip_lable">
                  <button className="yes" onClick={() => removeRow(props.row.original.reference, props.row.original.id, props.row.original.codfou)}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
                  <button className="no" onClick={(event) => show('delete' + props.row.original.id + props.row.original.reference, 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
                </div>
              </div>
            </div>
          </div>;
        }
      },
    ],
    [i18n.language, isMobile, specialPrice],
  );

  const displayedColumns = useMemo(() => {

    return columnsOrderItems.filter(col => {
      if (!isMobile && col.id === 'expander') {

        return false;
      }

      return true;
    });
  }, [columnsOrderItems, isMobile]);

  const hiddenColumns = isMobile ? { hiddenColumns: ['supplier', 'status'] } : null;

  function filterByPrice(
    type: FilterType
  ) {
    if (type === 'all') {
      setDataTableFiltred(dataTable);

      return;
    }

    const filtered = dataTable.filter(item =>
      type === 'equal'
        ? item.price == item.current_aol_price
        : item.price != item.current_aol_price
    );

    setDataTableFiltred(filtered);
  }

  useEffect(() => {
    filterByPrice(filterSelected);
  }, [dataTable, filterSelected]);

  useEffect(() => {

    setCoefficient(props.orderSymmary ? props.orderSymmary[4].value : '-');

  }, [props.orderSymmary]);

  const handleSelectSpecialPrice = (checked: boolean) => {

    setSpecialPrice(checked);

    setOpenModalDiscount(checked);

    if (!checked) {

      setDataTable((prevData) => {
        const newData = prevData.map((item) => {
          const calculatedTaux = +(item.price / Number(item.buy_current_aol_price)).toFixed(2);

          return {
            ...item,
            taux: calculatedTaux || 0,
            buy_price: item.buy_current_aol_price || 0,
          };
        });

        // calculăm coeficientul pe baza noilor valori
        const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
        const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '0';

        setCoefficient(averageTauxFinal);

        return newData;
      });

    }

    if (checked && listCodesAndSuppliers.length > 0) {

      setDataTable((prevData) => {
        const newData = prevData.map((item) => {

          const codeSupplier = listCodesAndSuppliers.find(code => code.codfou === item.codfou);
          const individualDiscount = codeSupplier ? Number(codeSupplier.discount) : 0;

          const buyPrice = +(Number(item.buy_current_aol_price) - ((Number(item.buy_current_aol_price) * (individualDiscount + Number(allDiscount))) / 100));
          const taux = buyPrice > 0 ? +(item.price / buyPrice).toFixed(2) : 0;

          return {
            ...item,
            taux: taux,
            buy_price: + buyPrice.toFixed(2),
          };

        });

        // calculăm coeficientul pe baza noilor valori
        const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
        const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '0';

        setCoefficient(averageTauxFinal);

        return newData;
      });
    }
  };

  useEffect(() => {
    setSpecialPrice(props.hasSpecialPrice || false);
    setOpenModalDiscount(props.hasSpecialPrice || false);
  }, [props.hasSpecialPrice]);


  const handleDiscountChange = (e: React.ChangeEvent<HTMLInputElement>, codfou) => {
    const value = e.target.value;

    setDataTable((prevData) => {
      const newData = prevData.map((item) => {

        const buyPrice = +(Number(item.buy_current_aol_price) - ((Number(item.buy_current_aol_price) * (Number(value) + Number(allDiscount))) / 100));
        const taux = buyPrice > 0 ? +(item.price / buyPrice).toFixed(2) : 0;

        return item.codfou === codfou
          ? {
            ...item,
            taux: taux,
            buy_price: + buyPrice.toFixed(2),
          }
          : item;

      });

      // calculăm coeficientul pe baza noilor valori
      const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
      const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '-';

      setCoefficient(averageTauxFinal);

      return newData;
    });

    setListCodesAndSuppliers((prevList) =>
      prevList.map((item) =>
        item.codfou === codfou ? { ...item, discount: Number(value) } : item
      )
    );


  };

  const handleDiscountChangeGlobal = (e: React.ChangeEvent<HTMLInputElement>) => {

    const value = e.target.value;


    setDataTable((prevData) => {
      const newData = prevData.map((item) => {

        const codeSupplier = listCodesAndSuppliers.find(code => code.codfou === item.codfou);
        const individualDiscount = codeSupplier ? Number(codeSupplier.discount) : 0;

        const buyPrice = +(Number(item.buy_current_aol_price) - ((Number(item.buy_current_aol_price) * (individualDiscount + Number(value))) / 100));
        const taux = buyPrice > 0 ? +(item.price / buyPrice).toFixed(2) : 0;

        return {
          ...item,
          taux: taux,
          buy_price: + buyPrice.toFixed(2),
        };

      });

      // calculăm coeficientul pe baza noilor valori
      const sumTaux = newData.reduce((sum, item) => sum + (Number(item.taux) || 0), 0);
      const averageTauxFinal = sumTaux > 0 ? (sumTaux / newData.length).toFixed(2) : '-';

      setCoefficient(averageTauxFinal);

      return newData;
    });

    setAllDiscount(Number(value));

  };

  return (
    <div className="edit-client-order-details-container">
      <div className="edit-order-header">
        <div className="edit-order-header-left" >
          <div className="edit-order-header-item" >{t('_average_of_the_coefficients') + ' : ' + coefficient}</div>
          {/* <div className="checkbox" >
            <input
              type="checkbox"
              onChange={(e) =>
                handleSelectSpecialPrice(
                  e.target.checked
                )

              }
              checked={specialPrice}
            />{t('_special_price')}
          </div> */}

        </div>
        <div className="edit-order-header-right" >
          {/* <div className="discount"> <DefaultButton icon={faPercentage} text={t('_discount')} onClick={() => { setOpenModalDiscount(true); }} /> </div> */}
          <div className="edit-order-header-item">

            <Select
              className="select-dropdown"
              onChange={(option) => setFilterSelected(option!.value)}
              options={Status_Filter}
              placeholder={t('_status')}
              value={Status_Filter.find(option => option.value === filterSelected)}
              styles={{
                menu: provided => ({ ...provided, zIndex: 50 })
              }}
              isSearchable={false}
            />
          </div>
        </div>

      </div>
      {/* {openModalDiscount && (
        <div className="modal-special-price-info">
          <div className="discounts">
            <div className="discount" >
              <div className="item_group">
                <div className="input-item">
                  <TextInput defaultValue={t('_global_discount')} readOnly />
                </div>
              </div>
              <div className="item_group">
                <div className="input-item ">
                  <TextInput placeholder={t('_discount') + ' %'} type="number" min={0} step="any" onChange={(event) => handleDiscountChangeGlobal(event)} defaultValue={props.valueDiscount.find(item => item.codfou === 'global')?.discount ? props.valueDiscount.find(item => item.codfou === 'global')?.discount : (allDiscount ? Number(allDiscount) : '')} />
                </div>
              </div>
            </div>
            <hr />
            {
              listCodesAndSuppliers.map((item) => {
                return (
                  <div className="discount" key={item.codfou}>
                    <div className="item_group">
                      <div className="input-item">
                        <TextInput placeholder={t('_group')} defaultValue={item.supplier} readOnly />
                      </div>
                    </div>
                    <div className="item_group">
                      <div className="input-item ">
                        <TextInput placeholder={t('_discount') + ' %'} type="number" min={0} step="any" defaultValue={item.discount ? String(item.discount) : ''} onChange={(event) => handleDiscountChange(event, item.codfou)} />
                      </div>
                    </div>
                  </div>
                );
              })}

          </div>
          <div className="comment">
            <h4>{t('_comment')}</h4>
            <TextareaInput noResize rows={6} onChange={(e) => { setMessage(e.target.value); props.setIsModified(true); }} value={message} />
          </div>
        </div>
      )} */}
      <div className="edit-order-tables">


        <DefaultTable columns={displayedColumns} data={dataTableFiltred} hiddenColumns={hiddenColumns} />
      </div>

      {/* <Modal
        openModal={openModalDiscount}
        shouldCloseOnOverlayClick={false}
        setOpenModal={setOpenModalDiscount}
        childrenComponent={<OrderDiscountModal setOpenModal={setOpenModalDiscount} listCodesAndSuppliers={listCodesAndSuppliers} />}
      /> */}
    </div>

  );
};

export default EditClientOrderDetails;
